/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';
import Request from '../../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import Manipulator from '../../../utils/dom/manipulator';

const CLICK_EVENT = 'click';

class CoachesHomePage {
	constructor() {
		this._wrapper = SelectorEngine.findOne('.p-coaches-home-page');
		if (!this._wrapper) {
			return;
		}
		this.initEvents();
	}

	initEvents() {
		// Events on Tabs Changes and Searches
		const allBookmarkContainers = SelectorEngine.find('.lta-bookmark-container', this._wrapper);
		for (const container of allBookmarkContainers) {
			const addBookmarkButton = SelectorEngine.findOne('.lta-add-bookmark', container);
			const removeBookmarkButton = SelectorEngine.findOne('.lta-remove-bookmark', container);

			EventHandler.on(addBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(addBookmarkButton, 'page-id');
				this.addBookmark(event, pageId, removeBookmarkButton);
			});

			EventHandler.on(removeBookmarkButton, CLICK_EVENT, (event) => {
				const pageId = Manipulator.getDataAttribute(removeBookmarkButton, 'page-id');
				this.removeBookmark(event, pageId, addBookmarkButton);
			});
		}
	}

	async addBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/bookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	async removeBookmark(event, pageId, element) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const apiUrl = '/api/coachdetails/unbookmarkcontent';
			const responseData = await Request.post(apiUrl + '?pageId=' + pageId);

			const { Error, Response } = responseData;
			if (Error.errorCode == '00') {
				// For testing commented below code TODO: confirm approeach
				// event.target.classList.add('u-hidden');
				// element.classList.remove('u-hidden');
				window.location.reload();
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}
}

const globalMyResources = new CoachesHomePage();
export default globalMyResources;
